//  ----------      START   IMPORT  BLOCK       ----------
import { Modal } from 'react-bootstrap';
//  Context
import { useLanguage } from '../../../API/Context/LanguageContext';
//  Config
import VocabInstructionsDiagnosis from '../../../ConfigFiles/multilingual/VocabInstructionsDiagnosis';
import './MissingInfoModal.css';
//  ----------      END   IMPORT  BLOCK       ----------

const MissingInfoModal = ({ show, onHide }) => {
  //  Consume context.
  const { lan } = useLanguage()

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="wider-modal">
      <Modal.Header closeButton>
        <Modal.Title className="centered-modal-title">
          {VocabInstructionsDiagnosis.instructions_diagnosis_tittle[lan]}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>
            aaa
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MissingInfoModal;
